import Promise from 'bluebird';
import { has, includes, isEqual } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { RuntimeContext } from '../../../../common/RuntimeContext';
import { getDimension, getManyAbilities, postDimension, putDimension } from '../../../shared/actions';
import Page from '../../../shared/components/Page';
import PageContent from '../../../shared/components/PageContent';
import PageHeader from '../../../shared/components/PageHeader';
import DimensionForm from '../forms/Admin/DimensionForm/DimensionForm';

class AddOrEditDimension extends Component {
    static propTypes = {
        getDimension: PropTypes.func.isRequired,
        getManyAbilities: PropTypes.func.isRequired,
        postDimension: PropTypes.func.isRequired,
        putDimension: PropTypes.func.isRequired,

        abilitiesById: PropTypes.object,
        currentDimension: PropTypes.object,
        match: PropTypes.object,
        history: PropTypes.object
    };

    static contextType = RuntimeContext;

    componentDidMount() {
        const {
            match: { params }
        } = this.props;
        if (params.id) {
            this.props.getDimension({ id: params.id, pathsContext: this.context.pathsWeb });
        }
        this.props.getManyAbilities({ pathsContext: this.context.pathsWeb });
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.id !== prevProps.match.params.id) {
            this.props.getDimension({ id: this.props.match.params.id, pathsContext: this.context.pathsWeb });
        }
    }

    handleSubmit = (values) => {
        const { currentDimension, putDimension, postDimension } = this.props;
        const newDimension = {
            ...currentDimension,
            ...values
        };

        let submitPromise;
        if (!has(newDimension, '_id')) {
            submitPromise = postDimension({
                body: newDimension,
                pathsContext: this.context.pathsWeb
            });
        } else if (!isEqual(newDimension, currentDimension)) {
            submitPromise = putDimension({
                id: newDimension._id,
                body: newDimension,
                pathsContext: this.context.pathsWeb
            });
        } else {
            submitPromise = Promise.resolve();
        }
        return submitPromise.then(() => {
            this.props.history.push('/managecontentframework');
        });
    };

    handleCancel = () => {
        this.props.history.push('/managecontentframework');
    };

    render() {
        const {
            match: { path },
            currentDimension = {},
            abilitiesById
        } = this.props;
        const isNew = includes(path, 'new');
        const title = isNew ? 'Create New Dimension' : 'Edit Dimension Details';

        return (
            <Page>
                <PageHeader title={title} hideBackButton={true} />
                <PageContent className={''}>
                    <DimensionForm
                        currentDimension={currentDimension}
                        onSubmit={this.handleSubmit}
                        onCancel={this.handleCancel}
                        abilitiesById={abilitiesById}
                    />
                </PageContent>
            </Page>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const {
        auth: { isAuthenticated },
        dimensions: { byId },
        abilities
    } = state;
    const dimensionId = ownProps.match.params.id;
    const currentDimension = dimensionId ? byId[dimensionId] : {};
    return {
        isAuthenticated,
        currentDimension,
        abilitiesById: abilities.byId
    };
};

const mapDispatchToProps = (dispatch) => ({
    getDimension: (params) => dispatch(getDimension(params)),
    postDimension: (params) => dispatch(postDimension(params)),
    putDimension: (params) => dispatch(putDimension(params)),
    getManyAbilities: (params) => dispatch(getManyAbilities(params))
});

export const AddOrEditDimensionComponent = AddOrEditDimension;
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddOrEditDimension));
